var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "view-associated-actions-detail-dialog-container" },
    [
      _c("CustomDialogHeaderComponent", {
        staticClass: "header",
        attrs: { headerTitle: _vm.title },
      }),
      _vm.showSpinner
        ? _c("SpinnerLayerComponent", { staticClass: "spinner-layer" })
        : _c(
            "section",
            [
              _vm.hasRelatedActionList
                ? _c("HTMLTableComponent", {
                    key: _vm.text.table.name,
                    staticClass: "data-table",
                    attrs: {
                      tableData: _vm.tableData,
                      "button-text": _vm.text.buttonText,
                    },
                  })
                : _c("div", { staticClass: "info-message-container" }, [
                    _c("div", { staticClass: "info-message" }, [
                      _c("span", { class: [_vm.infoIcon, "icon"] }),
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.text.noAssociatedAction)),
                      ]),
                    ]),
                  ]),
            ],
            1
          ),
      _c(
        "div",
        { staticClass: "custom-dialog-action-buttons-container" },
        [
          _vm.hasRelatedActionList
            ? _c("LfLabelButtonComponent", {
                staticClass: "button",
                attrs: {
                  text: _vm.text.download,
                  prependIcon: _vm.downloadIcon,
                  action: () => _vm.downloadData(),
                  variant: "text",
                },
              })
            : _vm._e(),
          _c("LfLabelButtonComponent", {
            staticClass: "button",
            attrs: {
              text: _vm.text.close,
              action: () => _vm.closeCustomDialogAction(),
              variant: "outlined",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }